/*
 * Autelpilot FAQ Data
 * Complete version: General FAQ + Feature FAQ + Model-Specific FAQ
 */
(function () {
  "use strict";

  function slug(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 72);
  }

  function makeFaqs(prefix, rows, startPriority) {
    var start = typeof startPriority === "number" ? startPriority : 10;

    return rows.map(function (row, index) {
      var answer = row[1] == null ? "" : String(row[1]);

      return {
        id: prefix + "-" + slug(row[0]) + "-" + (index + 1),
        question: row[0],
        answer: answer,
        priority: start + index * 10,
        enabled: answer.trim() !== ""
      };
    });
  }

  function mergeFaqs() {
    var output = [];

    for (var i = 0; i < arguments.length; i++) {
      output = output.concat(arguments[i] || []);
    }

    return output;
  }


  /* =========================================================
     EVO LITE ENTERPRISE COMMON FAQ
  ========================================================= */

  var LITE_COMMON = [
    [
      "What is the maximum flight time of the EVO Lite Enterprise Series?",
      "Maximum flight time in a laboratory environment with no wind is 40 minutes."
    ],
    [
      "What is the maximum transmission range of the EVO Lite Enterprise Series?",
      "In an open area that is unobstructed and free of interference, the FCC standard is 12km (7.4 miles)."
    ],
    [
      "Does the EVO Lite Enterprise Series support third-party Payloads?",
      "No, no PSDK interface."
    ],
    [
      "Does the EVO Lite Enterprise Series support MSDK?",
      "Yes, it supports complete MSDK paired with Autel Smart RC V3."
    ],
    [
      "How do I update the EVO Lite Enterprise firmware?",
      "Online mode (Use the OTA) and Offline mode (Use the SD Card)."
    ],
    [
      "Does the EVO Lite Enterprise support RTMP and GB28181 live streaming?",
      "It supports RTMP and GB28181 protocols. GB28181 live video streaming functionality is yet to be added in a future update."
    ],
    [
      "What remote controllers are compatible with the EVO Lite Enterprise?",
      "Standard RC: Autel Smart Remote SE V2, optional Autel Smart Remote V3."
    ]
  ];


  /* =========================================================
     EVO LITE 6K
  ========================================================= */

  var LITE_6K = [
    [
      "Does the EVO Lite 6K Enterprise actually record 6K video?",
      "The EVO Lite 6K Enterprise supports 6K photos and 4K/30fps video."
    ],
    [
      "Is the EVO Lite 6K Enterprise suitable for low-light or nighttime inspections?",
      "Yes, the EVO Lite 6K Enterprise has a 1-inch sensor 20MP camera with ISO up to 48,000 and adjustable aperture for low-light use, making it suitable for nighttime inspections, but it does not have a built-in flash."
    ],
    [
      "What are the camera specifications of the EVO Lite 6K Enterprise?",
      "The EVO Lite 6K Enterprise features a 1-inch CMOS sensor with 20 million pixels, an adjustable F2.8–F11 aperture, and up to 16× digital zoom. It supports ISO levels up to 48,000 in Night Mode, with maximum photo resolutions of 5472 × 3076 or 3840 × 2160. The maximum video resolution is 4K at 30 fps."
    ],
    [
      "Can the EVO Lite 6K Enterprise be used for waypoint missions?",
      "Yes. The EVO Lite Enterprise Series supports waypoint missions via the Autel Enterprise App."
    ],
    [
      "Can the EVO Lite 6K Enterprise be used for mapping and photogrammetry?",
      "For professional mapping, users should verify compatibility with the specific third-party software and its camera-data requirements."
    ],
    [
      "Can the EVO Lite 6K Enterprise camera be replaced with the 640T camera?",
      "Of course, the camera loads are interchangeable."
    ],
    [
      "What is the difference between the EVO Lite 6K Enterprise and the EVO Lite 640T Enterprise?",
      "The only difference is the camera payload, therefore their applicable scenarios will also differ."
    ],
    [
      "What are the differences between the EVO Lite 6K Enterprise combos?",
      "EVO Lite 6K Enterprise Basic Combos: Includes an EVO Lite 6K Enterprise Aircraft, Battery Charger & Power Cable, 1 Aircraft Battery, Controller Power Cable, 6.4\" Smart Controller SE V2, Documentation, and Gimbal Cover. EVO Lite 6K Enterprise Plus Combos: Adds two Aircraft Batteries, one Propeller Pair, and a Rugged Case to the EVO Lite 6K Enterprise Basic Combos."
    ]
  ];


  /* =========================================================
     EVO LITE 640T
  ========================================================= */

  var LITE_640T = [
    [
      "What is the EVO Lite 640T Enterprise best used for?",
      "EVO Lite 640T Enterprise typical applications include public safety, emergency response, search and rescue, industrial inspection, electrical inspection, and other tasks requiring heat source identification."
    ],
    [
      "What are the thermal camera specifications of the EVO Lite 640T Enterprise?",
      "The EVO Lite 640T Enterprise is equipped with a 640 × 512 uncooled VOx microbolometer thermal imager. It has a focal length of 9.1 mm, an aperture of F1.0, a sensitivity of ≤50 mK at F1.0 and 25°C, and supports up to 16x digital zoom."
    ],
    [
      "What temperature range can the EVO Lite 640T Enterprise measure?",
      "The EVO Lite 640T Enterprise supports two radiation thermometry modes. In high-gain mode, the measurement range is -20°C to 150°C; while in low-gain mode, the measurement range is wider, from 0°C to 550°C. Under specified environmental conditions, the radiation measurement accuracy is ±3°C or ±3% of the reading, whichever is greater."
    ],
    [
      "How far can the EVO Lite 640T Enterprise accurately measure temperature?",
      "The precise temperature measurement distance of the EVO Lite 640T Enterprise is 1 to 25 meters. This thermal imager supports center, point, and rectangular area radiation measurements and features high and low temperature alarms. Actual measurement performance may vary depending on environmental conditions, target attributes, distance, and other factors."
    ],
    [
      "Does the EVO Lite 640T Enterprise support radiometric thermal imaging?",
      "Yes. The EVO Lite 640T Enterprise supports radiation thermal measurements using center, point, and rectangular area measurement modes. Its thermal images contain temperature information and can be analyzed using a dedicated SDK and PC tools. The system also supports high and low temperature alarms and multiple thermal image color palettes."
    ],
    [
      "What is the difference between the EVO Lite 640T Enterprise and EVO Lite 6K Enterprise?",
      "The main difference lies in the imaging system. The EVO Lite 6K Enterprise features a 1-inch 20-megapixel visible light camera; the EVO Lite 640T Enterprise features a 48-megapixel visible light camera and a 640 × 512 thermal imaging camera."
    ],
    [
      "What are the differences between EVO Lite 640T Enterprise combos?",
      "EVO Lite 640T Enterprise Basic Combos: Includes an EVO Lite 640T Enterprise Aircraft, Battery Charger & Power Cable, 1 Aircraft Battery, Controller Power Cable, 6.4\" Smart Controller SE V2, Documentation, and Gimbal Cover.\n\nEVO Lite 640T Enterprise Plus Combos: Adds two Aircraft Batteries, one Propeller Pair, and a Rugged Case to the EVO Lite 640T Enterprise Basic Combos."
    ],
    [
      "Can the EVO Lite 640T Enterprise camera be replaced with the 6K camera?",
      "Of course, the camera loads are interchangeable."
    ]
  ];


  /* =========================================================
     EVO II V3 COMMON
  ========================================================= */

  var V3_COMMON = [
    [
      "What is the maximum wind resistance of the EVO II V3 Series?",
      "The EVO II V3 Series supports up to Level 8 wind resistance."
    ],
    [
      "Does the EVO II V3 Series support a TF card?",
      "Yes. The aircraft supports a TF card and also includes 8GB of built-in internal storage."
    ],
    [
      "Are the gimbal cameras of the EVO II V3 Series interchangeable?",
      "Yes. The gimbal cameras of the EVO II Pro V3 and EVO II Dual 640T V3 are interchangeable."
    ],
    [
      "Can EVO II V3 Series cameras be used with EVO II V2 drones?",
      "No. EVO II V3 Series cameras are not compatible with EVO II V2 aircraft because the firmware versions are different."
    ],
    [
      "Can the downward fill light be switched on manually?",
      "Yes. It can be turned on or off manually, or operate automatically according to environmental conditions."
    ],
    [
      "What is the effective image transmission distance?",
      "The maximum image transmission distance is up to 9 miles under FCC standards and up to 5 miles under CE standards for the referenced EVO II V3 configuration."
    ],
    [
      "Can the battery be used in low-temperature environments?",
      "Yes, but battery life may be reduced in low temperatures. For better performance, it is recommended to keep the battery temperature above 15°C before flight."
    ],
    [
      "How do I update the firmware?",
      "Firmware can be updated through the Autel Explorer app (Android) or by manually downloading the firmware package from the official website."
    ]
  ];


  /* =========================================================
     EVO II DUAL SERIES COMMON
  ========================================================= */

  var DUAL_SERIES = [
    [
      "What is the difference between the EVO II Dual 640T Series?",
      "EVO II Dual 640T V3: Visible light + 640×512 thermal imaging.\n\nEVO II Dual 640T RTK V3: Adds RTK capabilities to the existing camera.\n\nEVO II Dual Enterprise V3: Adds support for Enterprise modular accessories."
    ]
  ];


  /* =========================================================
     EVO II PRO V3 EXTRA FAQ
     前3个问题已经在 pro_camera
  ========================================================= */

  var PRO_V3_EXTRA = [
    [
      "How does the EVO II Pro V3 perform in low-light photography?",
      "The Autel EVO II Pro V3 boasts a 1-inch sensor, an adjustable aperture of f/2.8-f/11, high ISO up to 44,000 in low light, and Moonlight Algorithm 2.0 further enhances image quality, making it ideal for low-light shooting."
    ],
    [
      "How do I pair the EVO II Pro V3 with the Smart Controller V3?",
      "The EVO II Pro V3 comes standard with the Smart Controller SE. If you choose to pair the Smart Controller V3, ensure that both devices use compatible software/firmware during the pairing process, following the prompts in the App/Controller."
    ],
    [
      "Are the remote controls for the EVO II 640T V3 and EVO II Pro V3 interchangeable?",
      "No. The EVO II Pro V3 uses the Autel Smart Controller SE, and the EVO II 640T V3 uses the Autel Smart Controller V3. The EVO II Pro V3 can be upgraded to the Autel Smart Controller V3, but the EVO II 640T V3 cannot be used with the Autel Smart Controller SE."
    ],
    [
      "Can the EVO II Pro V3 be used for photogrammetry?",
      "Yes, it can be used for photogrammetry, but it is not an RTK mapping platform, and the measurement results may have errors."
    ],
    [
      "Can the EVO II Pro V3 be used with an RTK module?",
      "No, the EVO II Pro V3 platform does not have a PSDK interface."
    ]
  ];


  /* =========================================================
     EVO II DUAL 640T V3
  ========================================================= */

  var DUAL_V3 = [
    [
      "What is the thermal resolution of the EVO II Dual 640T V3?",
      "The thermal camera uses a 640 × 512 thermal imaging sensor."
    ],
    [
      "What thermal zoom does the EVO II Dual 640T V3 support?",
      "1-16x zoom."
    ],
    [
      "Can the EVO II Dual 640T V3 measure temperature accurately?",
      "Temperature measurement accuracy is ±3°C or ±3%, with a recommended temperature measurement distance of 2–20 meters under the specified environmental conditions."
    ],
    [
      "How do I analyze thermal images captured by the EVO II Dual 640T V3?",
      "Autel users can use the IR PC TOOL temperature analysis tool for free for post-temperature analysis."
    ],
    [
      "Does the EVO II Dual 640T V3 record temperature data in thermal video?",
      "Yes, the Autel EVO II Dual 640T V3 can record radiative temperature data in thermal video. However, complete temperature analysis and post-processing are primarily extracted from still images."
    ],
    [
      "Can the EVO II Dual 640T V3 be used for thermal mapping?",
      "Yes. While this aircraft model wasn't specifically designed for mapping, its functionality can meet mapping needs, such as 2D and 3D modeling."
    ],
    [
      "Can the EVO II Dual 640T V3 capture thermal images during waypoint or mapping missions?",
      "Yes."
    ],
    [
      "What are the best uses for the EVO II Dual 640T V3?",
      "The EVO II Dual 640T V3 is ideal for solar panel inspection, public safety, search and rescue, roof inspection, and electrical inspection."
    ]
  ];


  /* =========================================================
     EVO II RTK COMMON
  ========================================================= */

  var RTK_COMMON = [
    [
      "What is the main difference between EVO II RTK Series products and other EVO II Series products?",
      "EVO II RTK models add a high-precision RTK positioning and navigation system for centimeter-level positioning applications."
    ],
    [
      "What is the effective image transmission range of the EVO II RTK Series?",
      "In an open environment without obstruction or interference, the referenced FAQ states up to 9 miles under FCC standards and up to 5 miles under CE standards."
    ],
    [
      "Can the aircraft continue mapping if the image transmission signal is temporarily lost?",
      "If the image transmission signal is temporarily lost, the aircraft can continue the mapping task after the connection is restored."
    ],
    [
      "What is the screen size and resolution of the Smart Controller V3?",
      "The Autel Smart Controller V3 features a 7.9-inch ultra-bright touchscreen with a resolution of 2048 × 1536 at 60 fps."
    ],
    [
      "Which RTK base station is supported?",
      "The EVO II RTK Series supports the Autel A-RTK base station."
    ],
    [
      "What is the RTK positioning accuracy?",
      "RTK positioning accuracy is 1 cm + 1 ppm horizontally and 1.5 cm + 1 ppm vertically."
    ],
    [
      "What is the difference between RTK and PPK, and which should I use?",
      "RTK and PPK are both centimeter-level positioning methods. RTK is recommended when real-time positioning is required and a reliable communication link is available. PPK is better suited when real-time positioning is not required or communication is unreliable."
    ],
    [
      "Does the EVO II RTK Series provide relative or absolute coordinates?",
      "The EVO II RTK Series provides absolute coordinates."
    ],
    [
      "What type of propeller is it equipped with?",
      "Low-noise propeller."
    ]
  ];


  /* =========================================================
     EVO II PRO RTK V3
  ========================================================= */

  var PRO_RTK = [
    [
      "What camera does the EVO II Pro RTK V3 use?",
      "The EVO II Pro RTK V3 is equipped with a Sony 1-inch CMOS image sensor with 20M effective pixels."
    ],
    [
      "Does the EVO II Pro RTK V3 support lossless zoom?",
      "It can achieve 3x lossless zoom."
    ],
    [
      "How do I connect my EVO II Pro RTK V3 to an NTRIP service?",
      "First, you need a network RTK account. Then, update the firmware of both the aircraft and controller to the latest version for pairing. Connect the remote controller to the internet. In the RTK settings, find the custom NTRIP settings, enter the NTRIP information, and verify the connection."
    ],
    [
      "Can the EVO II Pro RTK V3 work with Trimble or Topcon GNSS base stations?",
      "The EVO II RTK series supports A-RTK base stations and third-party RTK base stations with the NTRIP protocol."
    ],
    [
      "Why is my EVO II Pro RTK V3 connected to NTRIP but not achieving an RTK FIX?",
      "Successful connection does not guarantee RTK FIX. After connecting, you need to rule out factors such as obstructed sky view, poor network connection, incorrect mount point, loading time, and the distance to the base station."
    ],
    [
      "Do I need GCPs when using the EVO II Pro RTK V3?",
      "The EVO II RTK series V3 can connect to the NTRIP network, providing centimeter-level accuracy without GCPs."
    ],
    [
      "Can the EVO II Pro RTK V3 be used for 2D and 3D photogrammetry missions?",
      "Absolutely. EVO II Pro RTK V3 positioning data can be used to create accurate 2D and 3D models in aerial site surveys."
    ],
    [
      "Can the Autel Robotics EVO II Pro RTK V3 be used to generate 2-foot spacing contour maps in a CAD system?",
      "Yes, but the actual accuracy depends on the surveying conditions and data processing quality."
    ]
  ];


  /* =========================================================
     EVO II DUAL 640T RTK V3
  ========================================================= */

  var DUAL_RTK = [
    [
      "Does the EVO II 640T RTK V3 support lossless zoom?",
      "It can achieve 4x lossless zoom."
    ],
    [
      "What is the difference between the EVO II Dual 640T V3 and 640T RTK V3?",
      "EVO II Dual 640T V3 = thermal imaging.\n\nEVO II Dual 640T RTK V3 = thermal imaging + RTK."
    ],
    [
      "How do I connect the EVO II Dual 640T RTK V3 to an NTRIP service?",
      "First, you need a network RTK account. Then, update the firmware of both the aircraft and controller to the latest version for pairing. Connect the remote controller to the internet. In the RTK settings, find the custom NTRIP settings, enter the NTRIP information, and verify the connection."
    ],
    [
      "Can the EVO II Dual 640T RTK V3 work with a local RTK base station?",
      "Yes. It supports A-RTK base stations and third-party RTK base stations with the NTRIP protocol."
    ],
    [
      "Does RTK improve the accuracy of thermal imaging mapping?",
      "RTK can improve aircraft location and geotagging accuracy, but it does not improve the temperature measurement accuracy of the thermal imaging camera."
    ],
    [
      "Do I need GCPs when using the EVO II Dual 640T RTK V3?",
      "The EVO II RTK series V3 can connect to the NTRIP network, providing centimeter-level accuracy without GCPs."
    ],
    [
      "In which industries can the EVO II Dual 640T RTK V3 be used?",
      "The EVO II Dual 640T RTK V3 supports thermal hotspot detection, RGB inspection, geospatial positioning, and large-area mapping, making it ideal for solar farm inspection and mapping, large-area thermal surveys, and infrastructure inspection."
    ],
    [
      "Does the EVO II Dual 640T RTK V3 support PPK?",
      "It supports PPK and can record raw satellite observation data and other information."
    ]
  ];


  /* =========================================================
     EVO II ENTERPRISE COMMON
  ========================================================= */

  var ENTERPRISE_COMMON = [
    [
      "What is the main difference between EVO II Enterprise drones and other EVO II Series products?",
      "Enterprise versions add support for industry expansion accessories such as a spotlight, loudspeaker, strobe, and optional RTK module."
    ],
    [
      "How do I replace the expansion accessories?",
      "Power off the aircraft before removing or installing an expansion accessory. Loosen the mounting screws to remove an accessory; when installing, remove the protective cover, align the accessory with the interface and screw holes, and tighten it securely."
    ],
    [
      "What is the working range of the spotlight?",
      "The spotlight can assist the camera when operating at distances of approximately 30 meters."
    ],
    [
      "Can the spotlight intensity be adjusted?",
      "Yes. The spotlight can be turned on or off from the image transmission interface, and the illumination intensity can be adjusted."
    ],
    [
      "How loud is the loudspeaker?",
      "In the provided FAQ test conditions, sound intensity was approximately 120 dB at 1 m, 88 dB at 60 m, and 70 dB at 110 m."
    ],
    [
      "What is the effective distance of the strobe?",
      "Depending on environmental conditions, the strobe can be visible at distances of up to approximately 16,500 feet."
    ],
    [
      "What remote controller does the EVO II V3 Enterprise use?",
      "The EVO II V3 Enterprise comes standard with the Autel Smart Controller V3, featuring a 7.9-inch touchscreen with 2048 × 1536 resolution and up to 2000 nits of brightness."
    ],
    [
      "Which communication frequency bands does the remote controller support?",
      "Supported frequency bands include 902–928 MHz, 2.400–2.4835 GHz, and 5.725–5.850 GHz. Available frequencies vary by country and model."
    ],
    [
      "How long does it take to fully charge the battery?",
      "It takes approximately 90 minutes to fully charge one aircraft battery."
    ]
  ];


  /* =========================================================
     EVO II DUAL 640T ENTERPRISE V3
  ========================================================= */

  var DUAL_ENTERPRISE = [
    [
      "What is the difference between 640T V3 and 640T Enterprise V3?",
      "Compared with 640T V3, 640T Enterprise V3 has different drone body specifications and supports more expanded ecological accessories."
    ],
    [
      "Can I add an RTK Module to the 640T Enterprise V3?",
      "Yes. The 640T Enterprise V3 supports RTK modules."
    ],
    [
      "What industries can EVO Enterprise be used in?",
      "It can be used in law enforcement, power inspection, fire rescue, building inspection, and many other fields."
    ],
    [
      "What kind of propeller does EVO II Enterprise V3 have?",
      "EVO II Enterprise propeller."
    ]
  ];


  /* =========================================================
     EVO II PRO ENTERPRISE V3
  ========================================================= */

  var PRO_ENTERPRISE = [
    [
      "What intelligent shooting features are available on the EVO II Pro Enterprise V3?",
      "Dynamic Track, Automated Mission Planning, Parallel Track & Tripod Track, Orbit & Viewpoint Modes."
    ],
    [
      "Does changing the gimbal add more photography features in EVO II Enterprise Series?",
      "In the EVO II Enterprise series, you can freely switch between a 6K visible light camera and a dual-light thermal imaging camera. Switching to a thermal camera adds features that standard optical cameras cannot provide, such as radiative thermal data, split-screen viewing, and a thermal color palette."
    ],
    [
      "Is the RTK module compatible with the EVO II Pro Enterprise V3?",
      "Yes."
    ],
    [
      "What is the difference between the EVO II Pro Enterprise V3 and EVO II Pro V3?",
      "Compared with EVO II Pro V3, the EVO II Pro Enterprise adds industry expansion accessories such as spotlight, loudspeaker, strobe, and RTK module support. EVO II Enterprise aircraft also have larger propellers and carbon fiber arms."
    ],
    [
      "What kind of propeller does EVO II Enterprise V3 have?",
      "EVO II Enterprise propeller."
    ]
  ];


  /* =========================================================
     EVO MAX SERIES COMMON
  ========================================================= */

  var MAX_COMMON = [
    [
      "What's the maximum flight time of EVO Max Series?",
      "The maximum flight time is 42 mins without payload."
    ],
    [
      "What are the updates to SkyLink 3.0 compared with SkyLink 2.0?",
      "SkyLink 3.0 provides a transmission range of up to 20 kilometers, supports additional frequency bands including 2.4GHz, 5.2GHz, 5.8GHz, and 900MHz, and offers improved resistance to RF interference."
    ],
    [
      "Is Autel EVO Max Series dust and water resistant?",
      "Yes. Autel EVO Max Series is IP43 rated. However, water and dust resistance may decrease over time due to use and wear. Regular inspection and maintenance are recommended."
    ],
    [
      "What's the difference between the 4D mode and 3D mode of Autel EVO Max Series millimeter wave radar?",
      "Under 4D mode, the radar can detect objects using distance, speed, yaw angle, and pitch angle, with a speed range of ±60 m/s. Under 3D mode, the radar uses distance, speed, and yaw angle, with a speed range of ±28 m/s."
    ],
    [
      "Will the aircraft fall if the GPS system fails?",
      "No. Depending on the operating conditions, the aircraft can hover or return."
    ],
    [
      "What are the precautions for daily use?",
      "Before takeoff, check that the propellers are securely installed. When the aircraft is not in use, turn off the power to prevent accidental operation and store the aircraft in its protective case."
    ],
    [
      "Can I fly the aircraft indoors?",
      "Indoor flight is generally not recommended unless the environment is suitable and the operator can safely control the aircraft."
    ],
    [
      "Is the aircraft waterproof?",
      "The EVO Max Series is IP43 rated, but its water resistance may decrease after long-term use."
    ],
    [
      "What's the transmission range between remote controller and aircraft?",
      "In an open environment without interference, the maximum transmission range is up to 12.4 miles / 20 km under FCC standards and up to 4.3 miles / 7 km under CE standards."
    ],
    [
      "How many frequencies does the remote controller support?",
      "Supported frequency bands include 902–928MHz (FCC), 2.400–2.4835GHz, 5.150–5.250GHz (FCC, CE, UKCA), 5.725–5.850GHz (non-Japan), and 5.650–5.755GHz (Japan only). Operating frequencies vary by country and model."
    ],
    [
      "What is the capacity and energy of a single battery?",
      "The battery capacity is 8070mAh and the energy is 120Wh."
    ],
    [
      "How does the battery self-heating work?",
      "If the battery temperature is below 10°C after the battery is inserted and activated, self-heating can be triggered. It stops automatically after the aircraft takes off. If the battery temperature is below -10°C, the aircraft will not be allowed to take off."
    ],
    [
      "Can the payload be replaced?",
      "Yes. The modular design enables compatible payload replacement."
    ],
    [
      "What payloads are supported?",
      "Camera payloads include 4N and 4T. Other supported modules include RTK, spotlight, and loudspeaker accessories."
    ]
  ];


  /* =========================================================
     EVO MAX 4T
  ========================================================= */

  var MAX_4T = [
    [
      "What is the difference between the EVO Max 4T and 4T V2?",
      "Compared with the EVO Max 4T, the EVO Max 4T V2 includes improvements to the camera payload, aircraft structure, thermal management, and overall performance."
    ],
    [
      "What is the inspection coverage of Autel EVO Max 4T V2?",
      "At a fixed height of 200 meters and a side photo overlap rate of 10%, a single drone flight can effectively cover a ground area of approximately 2 square kilometers."
    ],
    [
      "What scenarios can EVO Max 4T V2 apply to?",
      "It can be used in fields such as law enforcement, power inspection, emergency response, search and rescue, and construction inspection."
    ],
    [
      "Does EVO Max 4T support inertial navigation?",
      "During EVO Max mission flight, the aircraft can support continued operation in certain environments where GNSS is unavailable or the remote-controller connection is interrupted."
    ],
    [
      "Does 4T V2 have a follow-flight function?",
      "It does not provide a traditional follow-flight function. The gimbal can remain locked on a selected target."
    ],
    [
      "Which battery does EVO Max 4T V2 use?",
      "The EVO Max 4T V2 uses the standardized ABX41-D Smart Flight Battery."
    ],
    [
      "Which propeller does the EVO Max 4T V2 use?",
      "The EVO Max 4T V2 uses the standardized 1136 Max propeller."
    ]
  ];


  /* =========================================================
     EVO MAX 4N
  ========================================================= */

  var MAX_4N = [
    [
      "What is the major difference between EVO Max 4N V2 and EVO Max 4T?",
      "The EVO Max 4N V2 uses a starlight camera designed for low-light and nighttime operations, while the EVO Max 4T uses a dedicated zoom camera for long-distance visual inspection."
    ],
    [
      "Can I use the batteries of EVO Max 4N V2 for EVO Max 4T, or the other way around?",
      "Yes. Compatible EVO Max 4T and EVO Max 4N configurations use the same standardized flight battery."
    ],
    [
      "Can the remote controller of EVO Max 4N V2 be used for EVO Max 4T and Autel EVO II series?",
      "It can be used with compatible aircraft configurations, but the corresponding firmware and software must be matched correctly."
    ],
    [
      "What scenarios can EVO Max 4N V2 apply to?",
      "The EVO Max 4N V2 is designed for nighttime and low-light missions such as search and rescue, power inspection, security, and law-enforcement operations."
    ],
    [
      "Does the EVO Max 4N have the same zoom capability as the EVO Max 4T?",
      "No. The EVO Max 4N uses a different imaging system. Its starlight camera supports 1–8x zoom, while its thermal imaging camera supports 1–16x zoom."
    ],
    [
      "Can the EVO Max 4N be used for thermal inspection?",
      "Yes. The EVO Max 4N includes thermal imaging capability."
    ]
  ];


  /* =========================================================
     EVO MAX RTK MODULE
  ========================================================= */

  var MAX_RTK = [
    [
      "What is the RTK positioning accuracy?",
      "RTK positioning accuracy is approximately 1 cm + 1 ppm horizontally and 1.5 cm + 1 ppm vertically."
    ],
    [
      "What is the difference between the EVO Max RTK Module and an EVO II RTK drone?",
      "The EVO Max Series gains RTK capability by installing an RTK module, while the EVO II RTK Series is designed as a dedicated RTK aircraft platform. Both can support high-precision positioning workflows depending on configuration."
    ],
    [
      "Can the EVO Max RTK Module work with a local RTK base station?",
      null
    ],
    [
      "How high is the image positioning accuracy of the EVO Max Series without an RTK module?",
      "Without an RTK module, positioning relies on standard GNSS and is generally at decimeter-level accuracy under suitable conditions."
    ],
    [
      "Does the EVO Max RTK Series provide measurements in relative or absolute coordinates?",
      "The EVO Max RTK Series provides absolute coordinate positioning."
    ]
  ];


  /* =========================================================
     EVO MAX LOUDSPEAKER + SPOTLIGHT
  ========================================================= */

  var MAX_SAR = [
    [
      "Can the EVO Max Loudspeaker & Spotlight Combo work independently?",
      "The loudspeaker and spotlight are integrated into one accessory. The operator can enable or disable the individual functions from the remote-controller interface."
    ],
    [
      "Can the EVO Max Loudspeaker & Spotlight Bundle have a replaceable gimbal?",
      "Yes. Compatible camera payloads can be switched, provided the aircraft and remote controller are using compatible firmware."
    ],
    [
      "How does the searchlight follow the gimbal?",
      "The searchlight follows the gimbal's pitch adjustment."
    ],
    [
      "What are the different modes of the loudspeaker?",
      "The loudspeaker can support pre-recorded audio and real-time voice broadcasting."
    ],
    [
      "What is the loudspeaker's sound intensity?",
      "The specified sound intensity is approximately 114 dB at 1 meter."
    ],
    [
      "Is the searchlight brightness adjustable?",
      "Yes. The searchlight provides three brightness levels, approximately 3 Lux, 7 Lux, and 30 Lux."
    ],
    [
      "Can the searchlight angle be adjusted manually?",
      "Yes. Manual angle adjustment is supported within an approximate 30°–90° range."
    ],
    [
      "What is the effective range of the searchlight?",
      "In referenced testing, the illuminated area was approximately 113 square meters at 50 meters altitude, 471 square meters at 100 meters, and 1,063 square meters at 150 meters."
    ]
  ];


  window.AUTEL_FAQ_DATA = {

    /* =========================================================
       1. GENERAL FAQ
       所有产品通用问题
    ========================================================= */

    general: [
      {
        id: "general-genuine",
        question: "Are all Autel drones sold by Autelpilot genuine?",
        answer: "Yes. All Autel drones sold by Autelpilot are 100% genuine Autel products.",
        priority: 10,
        enabled: true
      },

      {
        id: "general-us-version",
        question: "Are these U.S. versions?",
        answer: "Yes. Products sold on Autelpilot US are intended for the U.S. market unless otherwise stated on the product page.",
        priority: 20,
        enabled: true
      },

      {
        id: "general-shipping",
        question: "How long does shipping take?",
        answer: "Most in-stock orders shipped from our U.S. warehouse are typically delivered within 3–5 business days.",
        priority: 30,
        enabled: true
      },

      {
        id: "general-free-shipping",
        question: "Do you offer free shipping?",
        answer: "Yes. Free shipping is available on eligible orders within the United States.",
        priority: 40,
        enabled: true
      },

      {
        id: "general-warranty",
        question: "What warranty is included?",
        answer: "Autelpilot provides a 1-year warranty and lifetime technical support for eligible products.",
        priority: 50,
        enabled: true
      },

      {
        id: "general-support",
        question: "Do you provide technical support after purchase?",
        answer: "Yes. You can contact our support team with details, photos, or videos of the issue, and we will assist you with troubleshooting.",
        priority: 60,
        enabled: true
      }
    ],


    /* =========================================================
       2. FEATURE FAQ
       按功能 / 系列调用
    ========================================================= */

    features: {

      pro_camera: [
        {
          id: "evo-ii-pro-v3-shooting-formats",
          question: "What photo and video formats does the camera support?",
          answer: "Photo formats include JPEG and RAW. Video formats include MOV and MP4.",
          priority: 10,
          enabled: true
        },

        {
          id: "evo-ii-pro-v3-zoom-range",
          question: "What is the zoom range of the EVO II Pro V3 camera?",
          answer: "The camera supports 1–16x zoom, including up to 3x lossless zoom.",
          priority: 20,
          enabled: true
        },

        {
          id: "evo-ii-pro-v3-camera-modes",
          question: "What camera modes are available?",
          answer: "Available modes include single shooting, continuous shooting, timed shooting, night shooting, long exposure, and HDR imaging.",
          priority: 30,
          enabled: true
        }
      ],


      thermal: [
        {
          id: "feature-thermal-use",
          question: "What can thermal imaging be used for?",
          answer: "Thermal imaging can help with inspection, search and rescue, firefighting, wildlife observation, public safety, and other applications where temperature differences need to be identified.",
          priority: 10,
          enabled: true
        }
      ],


      rtk: [
        {
          id: "feature-rtk-purpose",
          question: "What is RTK used for?",
          answer: "RTK provides highly accurate positioning for applications such as surveying, mapping, inspection, and precision flight operations.",
          priority: 10,
          enabled: true
        }
      ],


      night_vision: [
        {
          id: "feature-night-vision",
          question: "What is starlight night vision?",
          answer: "Starlight night vision is designed to capture clearer visible images in extremely low-light environments, making it useful for nighttime operations.",
          priority: 10,
          enabled: true
        }
      ],


      zoom: [
        {
          id: "feature-zoom",
          question: "What is the benefit of a zoom camera on an enterprise drone?",
          answer: "A zoom camera allows operators to inspect distant objects while maintaining a safer flight distance from structures, people, or hazardous areas.",
          priority: 10,
          enabled: true
        }
      ],


      laser_rangefinder: [
        {
          id: "feature-laser-rangefinder",
          question: "What is the laser rangefinder used for?",
          answer: "The laser rangefinder can measure the distance between the drone and a selected target, helping operators estimate target location and distance more accurately.",
          priority: 10,
          enabled: true
        }
      ],


      obstacle_avoidance: [
        {
          id: "feature-obstacle-avoidance",
          question: "Does obstacle avoidance work automatically?",
          answer: "Compatible Autel enterprise drones use multiple sensors to detect surrounding obstacles and assist the pilot during flight. Performance may vary depending on the environment and operating conditions.",
          priority: 10,
          enabled: true
        }
      ],


      speaker: [
        {
          id: "feature-speaker",
          question: "Can I play custom audio through the loudspeaker?",
          answer: "Compatible Autel loudspeaker accessories support voice broadcasting and may support recorded or custom audio depending on the aircraft and software configuration.",
          priority: 10,
          enabled: true
        }
      ],


      spotlight: [
        {
          id: "feature-spotlight",
          question: "What is the spotlight used for?",
          answer: "The spotlight provides additional illumination during nighttime inspection, search, public safety, and other low-light operations.",
          priority: 10,
          enabled: true
        }
      ],


      evo_lite_enterprise:
        makeFaqs(
          "evo-lite-enterprise-feature",
          LITE_COMMON
        ),


      evo_ii_v3_series:
        makeFaqs(
          "evo-ii-v3-series-feature",
          V3_COMMON
        ),


      evo_ii_dual_640t_series:
        makeFaqs(
          "evo-ii-dual-640t-series-feature",
          DUAL_SERIES
        ),


      evo_ii_rtk:
        makeFaqs(
          "evo-ii-rtk-feature",
          RTK_COMMON
        ),


      evo_ii_enterprise:
        makeFaqs(
          "evo-ii-enterprise-feature",
          ENTERPRISE_COMMON
        ),


      evo_max_series:
        makeFaqs(
          "evo-max-series-feature",
          MAX_COMMON
        ),


      evo_max_rtk:
        makeFaqs(
          "evo-max-rtk",
          MAX_RTK
        ),


      max_sar_bundle:
        makeFaqs(
          "evo-max-sar",
          MAX_SAR
        )
    },


    /* =========================================================
       3. MODEL-SPECIFIC FAQ
       产品 Handle 映射
    ========================================================= */

    models: {


      /* =====================================================
         EVO LITE 6K
      ===================================================== */

      evo_lite_6k: {

        handles: [
          "autel-evo-lite-6k-enterprise",
          "autel-robotics-evo-lite-6k-basic-combo"
        ],

        features: [
          "evo_lite_enterprise"
        ],

        faqs:
          makeFaqs(
            "evo-lite-6k",
            LITE_6K
          )
      },


      /* =====================================================
         EVO LITE 640T
      ===================================================== */

      evo_lite_640t: {

        handles: [
          "autel-evo-lite-640t-enterprise",
          "autel-robotics-evo-lite-640t-basic-combo"
        ],

        features: [
          "thermal",
          "zoom",
          "evo_lite_enterprise"
        ],

        faqs:
          makeFaqs(
            "evo-lite-640t",
            LITE_640T
          )
      },


      /* =====================================================
         EVO II PRO V3
      ===================================================== */

      evo_ii_pro_v3: {

        handles: [
          "autel-robotics-evo-ii-pro-6k-v3",
          "autel-robotics-evo-ii-pro-v3-camera-drone-grey",
          "autel-robotics-evo-ii-pro-v3-three-batteries-bundle",
          "autel-robotics-evo-ii-pro-v3-grey-3-batteries-bundle",
          "orange-autel-evo-ii-pro-v3-advanced-bundle",
          "grey-autel-evo-ii-pro-v3-advanced-bundle"
        ],

        features: [
          "pro_camera",
          "evo_ii_v3_series"
        ],

        faqs:
          makeFaqs(
            "evo-ii-pro-v3",
            PRO_V3_EXTRA
          )
      },


      /* =====================================================
         EVO II DUAL 640T V3
      ===================================================== */

      evo_ii_dual_640t_v3: {

        handles: [
          "evo-ii-dual-640t-rugged-bundle-v3"
        ],

        features: [
          "thermal",
          "zoom",
          "evo_ii_v3_series",
          "evo_ii_dual_640t_series"
        ],

        faqs:
          makeFaqs(
            "evo-ii-dual-640t-v3",
            DUAL_V3
          )
      },


      /* =====================================================
         EVO II PRO RTK V3
      ===================================================== */

      evo_ii_pro_rtk_v3: {

        handles: [
          "autel-evo-ii-pro-rtk-v3"
        ],

        features: [
          "pro_camera",
          "rtk",
          "evo_ii_v3_series",
          "evo_ii_rtk"
        ],

        faqs:
          makeFaqs(
            "evo-ii-pro-rtk-v3",
            PRO_RTK
          )
      },


      /* =====================================================
         EVO II DUAL 640T RTK V3
      ===================================================== */

      evo_ii_dual_640t_rtk_v3: {

        handles: [
          "autel-evo-ii-dual-640t-rtk-v3"
        ],

        features: [
          "thermal",
          "zoom",
          "rtk",
          "evo_ii_v3_series",
          "evo_ii_dual_640t_series",
          "evo_ii_rtk"
        ],

        faqs:
          makeFaqs(
            "evo-ii-dual-640t-rtk-v3",
            DUAL_RTK
          )
      },


      /* =====================================================
         EVO II DUAL 640T ENTERPRISE V3
      ===================================================== */

      evo_ii_dual_640t_enterprise_v3: {

        handles: [
          "evo-ii-dual-640t-v3-enterprise-bundle"
        ],

        features: [
          "thermal",
          "zoom",
          "speaker",
          "spotlight",
          "evo_ii_v3_series",
          "evo_ii_dual_640t_series",
          "evo_ii_enterprise"
        ],

        faqs:
          makeFaqs(
            "evo-ii-dual-640t-enterprise-v3",
            DUAL_ENTERPRISE
          )
      },


      /* =====================================================
         EVO II DUAL 640T RTK ENTERPRISE V3

         重点：
         同时展示：
         - 640T RTK 问题
         - 640T Enterprise 问题
      ===================================================== */

      evo_ii_dual_640t_rtk_enterprise_v3: {

        handles: [
          "autel-robotics-evo-ii-dual-640t-rtk-v3-enterprise-bundle"
        ],

        features: [
          "thermal",
          "zoom",
          "rtk",
          "speaker",
          "spotlight",

          "evo_ii_v3_series",
          "evo_ii_dual_640t_series",
          "evo_ii_rtk",
          "evo_ii_enterprise"
        ],

        faqs:
          mergeFaqs(

            makeFaqs(
              "evo-ii-dual-640t-rtk-enterprise-rtk",
              DUAL_RTK
            ),

            makeFaqs(
              "evo-ii-dual-640t-rtk-enterprise-ent",
              DUAL_ENTERPRISE,
              100
            )

          )
      },


      /* =====================================================
         EVO II PRO ENTERPRISE V3
      ===================================================== */

      evo_ii_pro_enterprise_v3: {

        handles: [
          "evo-ii-enterprise-v3"
        ],

        features: [
          "pro_camera",
          "speaker",
          "spotlight",
          "evo_ii_v3_series",
          "evo_ii_enterprise"
        ],

        faqs:
          makeFaqs(
            "evo-ii-pro-enterprise-v3",
            PRO_ENTERPRISE
          )
      },


      /* =====================================================
         EVO MAX 4T
      ===================================================== */

      evo_max_4t: {

        handles: [
          "autel-robotics-evo-max-4t",
          "autel-robotics-evo-max-4t-v2",
          "autel-robotics-evo-max-4t-xe"
        ],

        features: [
          "thermal",
          "zoom",
          "laser_rangefinder",
          "obstacle_avoidance",
          "evo_max_series"
        ],

        faqs:
          makeFaqs(
            "evo-max-4t",
            MAX_4T
          )
      },


      /* =====================================================
         EVO MAX 4T
         LOUDSPEAKER + SPOTLIGHT
      ===================================================== */

      evo_max_4t_sar: {

        handles: [
          "autel-robotics-evo-max-4t-loudspeaker-and-spotlight-bundle"
        ],

        features: [
          "thermal",
          "zoom",
          "laser_rangefinder",
          "obstacle_avoidance",

          "speaker",
          "spotlight",

          "evo_max_series",
          "max_sar_bundle"
        ],

        faqs:
          makeFaqs(
            "evo-max-4t-sar",
            MAX_4T
          )
      },


      /* =====================================================
         EVO MAX 4T + RTK

         重点：
         EVO Max 4T
         +
         EVO Max RTK Module FAQ
      ===================================================== */

      evo_max_4t_rtk: {

        handles: [
          "autel-robotics-evo-max-4t-with-rtk-module"
        ],

        features: [
          "thermal",
          "zoom",
          "laser_rangefinder",
          "obstacle_avoidance",

          "rtk",

          "evo_max_series",
          "evo_max_rtk"
        ],

        faqs:
          makeFaqs(
            "evo-max-4t-rtk",
            MAX_4T
          )
      },


      /* =====================================================
         EVO MAX 4N
      ===================================================== */

      evo_max_4n: {

        handles: [
          "autel-robotics-evo-max-4n",
          "autel-robotics-evo-max-4n-v2"
        ],

        features: [
          "thermal",
          "night_vision",
          "zoom",
          "laser_rangefinder",
          "obstacle_avoidance",

          "evo_max_series"
        ],

        faqs:
          makeFaqs(
            "evo-max-4n",
            MAX_4N
          )
      },


      /* =====================================================
         EVO MAX 4N
         LOUDSPEAKER + SPOTLIGHT
      ===================================================== */

      evo_max_4n_sar: {

        handles: [
          "autel-robotics-evo-max-4n-speaker-and-spotlight-combo-bundle"
        ],

        features: [
          "thermal",
          "night_vision",
          "zoom",
          "laser_rangefinder",
          "obstacle_avoidance",

          "speaker",
          "spotlight",

          "evo_max_series",
          "max_sar_bundle"
        ],

        faqs:
          makeFaqs(
            "evo-max-4n-sar",
            MAX_4N
          )
      },


      /* =====================================================
         EVO MAX 4N + RTK

         重点：
         EVO Max 4N
         +
         EVO Max RTK Module FAQ
      ===================================================== */

      evo_max_4n_rtk: {

        handles: [
          "autel-robotics-evo-max-4n-rtk-module-bundle"
        ],

        features: [
          "thermal",
          "night_vision",
          "zoom",
          "laser_rangefinder",
          "obstacle_avoidance",

          "rtk",

          "evo_max_series",
          "evo_max_rtk"
        ],

        faqs:
          makeFaqs(
            "evo-max-4n-rtk",
            MAX_4N
          )
      }

    }

  };

})();